<template>
  <b-modal id="createUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdata.createUserDataHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <UserDataCreate></UserDataCreate>
      </b-col>
    </b-row>
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<div class="float-right">-->
          <!--<b-button v-if="$store.state.userdata.update.updated" class="btn btn-secondary" @click="closeModal()">{{ $t('buttons.close') }}</b-button>-->
        <!--</div>-->
      <!--</b-col>-->
    <!--</b-row>-->
  </b-modal>
</template>

<script>
import UserDataCreate from '../Create.vue'
export default {
  name: 'CreateUserDataModal',
  components: {
    UserDataCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdata.create.show
    },
    close () {
      return this.$store.state.modals.userdata.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      action: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1) {
        this.$store.state.modals.userdata.create.show = 0
        this.$bvModal.show('createUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdata.create.close = 0
        this.$bvModal.hide('createUserDataModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
